'use client';

import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import { mongoAtlasPrivateLinkFlow } from './mongoAtlasPrivateLinkFlows';
import type { MongoAtlasPrivateLinkWizardState } from './mongoAtlasPrivateLinkWizardState';

export function MongoAtlasPrivateLinkWizard({
  atlasProjectId,
  cloudAccountId,
  prefill,
  onCreated,
}: {
  atlasProjectId: string;
  cloudAccountId: string;
  prefill?: { region: string; serviceName: string };
  onCreated: () => Promise<void>;
}) {
  const { rightPanel } = useWorkspace();

  const onFinish = async () => {
    await onCreated();
    return true;
  };

  return (
    <Wizard<MongoAtlasPrivateLinkWizardState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[mongoAtlasPrivateLinkFlow]}
      title='Set up PrivateLink'
      initialState={{
        setupMethod: 'ui',
        atlasProjectId,
        cloudAccountId,
        region: prefill?.region ?? '',
        serviceName: prefill?.serviceName ?? '',
        endpointServiceId: '',
        resume: !!prefill,
      }}
    />
  );
}
